import React, { useState, useEffect } from "react";
import PllTable from "../../../Components/layouts/StudentCourse/PllTable";
import PollModal from "../../../Components/layouts/StudentCourse/PollModal";
import { Modal } from "../../../Components/share/modal/Modal";
import useFetch from "../../../Hooks/useFetch";
import MainPagination from "../../../Components/share/Pageination/MainPagination";

function Poll() {
    const [polls, setPolls] = useState();
    const [modalbtn, setModalbtn] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const getUserPolls = useFetch({
        method: "GET",
        url: "BootCampSurveyQuestionService/11/surveys",
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setPolls,
    });
    //TODO : id bootcamp dynamic she

    useEffect(() => {
        getUserPolls.reFetch();
    }, [pagination]);

    return (
        <div>
            <div className="flex justify-between items-center">
                <h4 className="text-[2rem] text-purple-dark font-bold">
                    اطلاعات نظرسنجی های بوت کمپ
                </h4>
            </div>
            <PllTable
                list={polls?.results}
                header={header}
                showModal={setModalbtn}
            >
                <Modal show={modalbtn}>
                    <PollModal close={setModalbtn} />
                </Modal>
            </PllTable>
            <MainPagination
                pagination={pagination}
                setPagination={setPagination}
                data={polls?.results}
                pageSize={polls?.page_count}
            />
        </div>
    );
}

export default Poll;
const header = [
    { title: "نوع نظرسنجی" },
    { title: "تعداد سوالات" },
    { title: "زمان برگزاری" },
];
const list = [
    {
        id: 1,
        name: "پایان دوره",
        date: "20",
        test: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
    },
    {
        id: 2,
        name: "فرم ثبت نام",
        date: "20",
        test: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
    },
];
